// extracted by mini-css-extract-plugin
module.exports = {"amenitiesContainer":"styles_amenitiesContainer__9lIiC","icon":"styles_icon__YNBOV","amenity":"styles_amenity__HBF1_","hoverableContainer":"styles_hoverableContainer__6hSxC"};